export type BillingInterval = 'monthly' | 'yearly';

export type SubscriptionPlanId = 'free' | 'pro';

export type SubscriptionPlan = {
  id: SubscriptionPlanId;
  name: string;
  tagline: string;
  monthlyPriceUsd: number;
  yearlyPriceUsd: number;
  features: string[];
  highlighted?: boolean;
};

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'free',
    name: 'Free',
    tagline: 'First three months free, then daily limits',
    monthlyPriceUsd: 0,
    yearlyPriceUsd: 0,
    features: [
      'Unlimited puzzles and SRS review',
      'Full explorer access',
      'Reopen your 10 most recent replays',
      'One new replay game per day',
      '10 course lessons per day',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    tagline: 'Full EndChess access',
    monthlyPriceUsd: 5,
    yearlyPriceUsd: 35,
    highlighted: true,
    features: [
      'Unlimited puzzles and SRS review',
      'Full explorer and replay library',
      'All courses and lesson drills',
      'Priority engine analysis',
      'Advanced stats and progress tracking',
    ],
  },
];

export function planPriceForInterval(
  plan: SubscriptionPlan,
  interval: BillingInterval,
): number {
  return interval === 'yearly' ? plan.yearlyPriceUsd : plan.monthlyPriceUsd;
}

export function yearlySavingsPercent(plan: SubscriptionPlan): number {
  if (plan.monthlyPriceUsd <= 0) {
    return 0;
  }
  const yearlyAtMonthlyRate = plan.monthlyPriceUsd * 12;
  return Math.round(
    ((yearlyAtMonthlyRate - plan.yearlyPriceUsd) / yearlyAtMonthlyRate) * 100,
  );
}

export function formatUsd(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatRenewalDate(isoDate: string | undefined): string | null {
  if (!isoDate) {
    return null;
  }
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}
